export default __webpack_public_path__ + "static/media/bspring31.fd927d43.webp";